import { render, staticRenderFns } from "./productSelector.vue?vue&type=template&id=7d22ce0e&scoped=true&"
import script from "./productSelector.vue?vue&type=script&lang=js&"
export * from "./productSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d22ce0e",
  null
  
)

export default component.exports